// Module
var code = "<svg width=\"32\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.999 11h15.993M7.999 15.998h9.995M7.999 20.996h13.994\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg> ";
// Exports
module.exports = code;